import { connect } from 'react-redux';
import UserAccount from '../Component/UserAccount'
import {
  getUser, 
  getNotification, 
  getPets,
  getAccountInfo, 
  UpdatePets, 
  addPets,
  getServiceOrder, 
  deletePets, 
  updateUser,
  updateNotification, 
  getMessagesList,
  getReasonList,
  createMessage,
  messageReplay, 
  closeTicket, 
  getCardList, 
  addNewCard,
  deleteCard, 
  getMessagesCount, 
  getCSVData, 
  ViewService,
  pauseService, 
  getPauseService, 
  deletePauseService,
  getPastUpcomingService, 
  addReviewInService, 
  UpdateCard,
  addServiceBag, 
  getAccountListing, 
  getProposalsListing, 
  getProposalPdf,
  getCommericalAccountInfo, 
  updateCommericalAccountInfo, 
  getCommunityInfo, 
  updateCommunityInfo, 
  getPayment,
  printInvoice, 
  getServiceStats, 
  getGeocodeAddress, 
  resetGeocodeAddress,
  getInvoiceCreditMemoList,
  getBillingInfo,
  checkZipCode,
  updateCustomerLastCompletedStep
} from '../../../Actions';

const mapStateToProps = (state) => {

  const {
    user,
    NotificationList,
    DogList,
    AccountInfo,
    updatedDog,
    addedDog,
    deletedPets,
    serviceOrder,
    updatedUser,
    updatedNotification,
    getMessages,
    getReasons,
    createdMessage,
    messageReply,
    ticketClosed,
    getCard,
    newCard,
    cardDeleted,
    messageCount,
    viewMyService,
    servicePause,
    pauseServiceList,
    pauseServiceDeleted,
    UPASTService,
    addReview,
    updatedCard,
    addBag,
    GetInvoice,
    GetCommercialInfo,
    UpdateCommercialUser,
    CommunityInfo,
    UpdateCommunity,
    GetPayment,
    DownloadInvoice,
    ServiceStats,
    GoogleApi,
    enquiry,
    BillingInfo,
    GetProposal,
    zipcodeReducers
  } = state;

  return {
    user,
    NotificationList,
    DogList,
    AccountInfo,
    updatedDog,
    addedDog,
    deletedPets,
    serviceOrder,
    updatedUser,
    updatedNotification,
    getMessages,
    getReasons,
    createdMessage,
    messageReply,
    ticketClosed,
    getCard,
    newCard,
    cardDeleted,
    messageCount,
    viewMyService,
    servicePause,
    pauseServiceList,
    pauseServiceDeleted,
    UPASTService,
    addReview,
    updatedCard,
    addBag,
    GetInvoice,
    GetCommercialInfo,
    UpdateCommercialUser,
    CommunityInfo,
    UpdateCommunity,
    GetPayment,
    DownloadInvoice,
    ServiceStats,
    GoogleApi,
    enquiry,
    BillingInfo,
    GetProposal,
    zipcodeReducers
  }
}

const actionCreators = {
  getUser,
  getNotification,
  getAccountInfo,
  getPets,
  UpdatePets,
  addPets,
  getServiceOrder,
  deletePets,
  updateUser,
  updateNotification,
  getMessagesList,
  getReasonList,
  createMessage,
  messageReplay,
  closeTicket,
  getCardList,
  addNewCard,
  deleteCard,
  getMessagesCount,
  getCSVData,
  ViewService,
  pauseService,
  getPauseService,
  deletePauseService,
  getPastUpcomingService,
  addReviewInService,
  UpdateCard,
  addServiceBag,
  getAccountListing,
  getProposalsListing,
  getProposalPdf,
  getCommericalAccountInfo,
  updateCommericalAccountInfo,
  getCommunityInfo,
  updateCommunityInfo,
  getPayment,
  printInvoice,
  getServiceStats,
  getGeocodeAddress,
  resetGeocodeAddress,
  getInvoiceCreditMemoList,
  getBillingInfo,
  checkZipCode,
  updateCustomerLastCompletedStep
};

export default (connect(mapStateToProps, 
  actionCreators)(UserAccount));
